import { BreakpointState } from '@angular/cdk/layout';
import { createActionGroup, props } from '@ngrx/store';

import { NinetyBreakpointNames } from './viewport.model';

export const ViewportActions = createActionGroup({
  source: 'Viewport Effects',
  events: {
    'Breakpoint Set': props<{ breakpointState: BreakpointState; currentScreenSize: NinetyBreakpointNames }>(),
    'Resize Set': props<{ pageHeight: number; pageWidth: number }>(),
    'Keyboard Visibility Changed': props<{ keyboardVisible: boolean }>(),
  },
});
